export default {
  USERNAME: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[A-Za-z0-9-.]+$/,
}
